module.exports = "<div class=commponent-add-container> <div class=input-box> <span class=title>名称</span> <input class=query-name-input type=text placeholder=建议名称不多于六个字> </div> <div class=button-box> <button class=save-btn>保存</button> <button class=cancel-btn>取消</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/dataGrid/data-table-toolbar/common-query-add/common-query-add.html
// module id = 2075
// module chunks = 50